import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { StackingContextLevel } from "styles/stacking-context-level";
import { withVar } from "themes/helpers";

export const iframeWrapperCss = css`
  height: 100%;
  width: 100%;
  overflow: hidden;

  > iframe {
    height: 100%;
    width: 100%;
  }
`;

export const loaderWrapperCss = css`
  position: absolute;
  text-align: center;
  height: 100%;
  width: 100%;
  padding-top: 100px;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  z-index: ${StackingContextLevel.FullOverlay};
`;
